export function IdealPlanRecommendationSkeleton() {
  return (
    <div className="animate-pulse px-5 pb-6 pt-2">
      <div className="h-4 w-36 rounded bg-[#F0F4F7]" />
      <div className="mt-3 h-16 w-full rounded bg-[#F0F4F7]" />
      <div className="mt-6 h-[132px] w-full rounded-xl bg-[#F0F4F7]" />
      <div className="mt-6 h-28 w-full rounded-xl bg-[#F0F4F7]" />
      <div className="mt-6 h-40 w-full rounded-xl bg-[#F0F4F7]" />
    </div>
  )
}
